import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  makeStyles, Paper, Toolbar, TextField, IconButton, Button,
} from '@material-ui/core';

import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ListIcon from '@material-ui/icons/ViewList';

import DevicesList from './DevicesList';
import Map from './map/Map';
import SelectedDeviceMap from './map/SelectedDeviceMap';
import CurrentPositionsMap from './map/CurrentPositionsMap';
import BottomMenu from './components/BottomMenu';
import { useTranslation } from './LocalizationProvider';
import PoiMap from './map/PoiMap';
import { api_call, console_log, empty, is_null } from './helpers/untils';
import { devicesActions, layoutActions } from './store';
import PaypalCreditLogsModal from './settings/PaypalCreditLogsModal';
import MainSort from './components/MainSort';
import CreditLogsModal from './settings/CreditLogsModal';
import EscrowLogsModal from './settings/EscrowLogsModal';
import { checkShowPaypalBanner, setSettingPersist } from './helpers/misc';
import { DEVICE_PAYMENT_STATUS, MACHINE_ENVIRONMENT } from './config/constant';
import DeviceImageUploadModal from './settings/DeviceImageUploadModal';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    left: 0,
    top: 0,
    margin: theme.spacing(1.5),
    width: theme.dimensions.drawerWidthDesktop,
    bottom: 56,
    zIndex: 1301,
    transition: 'transform .5s ease',
    backgroundColor: 'white',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      margin: 0,
    },
  },
  sidebarCollapsed: {
    transform: `translateX(-${theme.dimensions.drawerWidthDesktop})`,
    marginLeft: 0,
    [theme.breakpoints.down('md')]: {
      transform: 'translateX(-100vw)',
    },
  },
  paper: {
    zIndex: 1,
  },
  toolbar: {
    display: 'flex',
    padding: theme.spacing(0, 1),
    '& > *': {
      margin: theme.spacing(0, 0.25),
    },
  },
  deviceList: {
    flex: 1,
  },
  sidebarToggle: {
    position: 'fixed',
    left: theme.spacing(1.5),
    top: theme.spacing(3),
    borderRadius: '0px',
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      top: theme.spacing(3),
      left: 0,
    },
  },
  sidebarToggleText: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.only('xs')]: {
      display: 'none',
    },
  },
  sidebarToggleBg: {
    backgroundColor: 'white',
    color: '#777777',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  searchTextBox: {
    position: 'relative',
    marginRight: '8px',
    // paddingRight: '50px'
  },
  searchTextSpan: {
    position: 'absolute',
    right: "8px",
    top: "0px",
    bottom: "0px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
}));

const MainPage = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation()
  const theme = useTheme();
  const t = useTranslation();

  const user = useSelector((state) => state.session.user);
  const [escrowUser, setEscrowUser] = useState(user);
  useEffect(() => {
    if (user?.id) {
      setEscrowUser(user)
    }
  }, [user?.id])
  const [escrowLogsModalOpen, setEscrowLogsModalOpen] = useState(false);

  //////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    checkQueryParams();
  }, [])

  const checkQueryParams = async () => {
    const params = new URLSearchParams(location.search)
    if (params) {
      let mainUrl = `/main`
      const showEscrowPage = params.get("showEscrowPage")
      if (showEscrowPage) {
        if (!user.administrator) {
          dispatch(layoutActions.closeDeviceListMenu());
          setEscrowLogsModalOpen(true)

          params.delete("showEscrowPage");
          const queryString = params.toString()
          if (queryString) {
            mainUrl = `?${queryString}`
          }
          window.history.pushState('', '', mainUrl);
          return true
        }
      }

      const creditLogDevice = params.get("creditLogDevice")
      if (creditLogDevice) {
        if (!user.administrator) {
          params.delete("creditLogDevice");
          const queryString = params.toString()
          if (queryString) {
            mainUrl = `?${queryString}`
          }
          window.history.pushState('', '', mainUrl);
          await loadDeviceInfo(creditLogDevice, "showDeviceCreditLogsPage")
          return true
        }
      }

      /////////////////////////////////////////////////////////////////////
      const token = params.get('token');
      const deviceId = params.get('deviceId');
      const page = params.get('page');
      if (!token) {
        // for webview
        if (deviceId) {
          // params.delete("deviceId");
          // const queryString = params.toString();
          // if (queryString) {
          //   mainUrl = `?${queryString}`
          // }
          // window.history.pushState('', '', mainUrl);
          localStorage.setItem('deviceId', deviceId);
          localStorage.setItem('page', page);
          await loadDeviceInfo(deviceId, "", params);
          return true;
        }
      }
      else {
        ///////////// for mobile web view ///////////////////////
        if (token && deviceId) {
          localStorage.setItem('m_token', token);
          localStorage.setItem('fromMobile', true);
          localStorage.setItem('deviceId', deviceId);
          localStorage.setItem('page', page);
          if (page === "deviceCreditLogs") {
            await loadDeviceInfo(deviceId, "showDeviceCreditLogsPage")
          }
          else if (page === "upload") {
            await loadDeviceInfo(deviceId, "upload")
          }
          else {
            await loadDeviceInfo(deviceId, "")
          }
        } else {
          localStorage.removeItem('fromMobile');
          localStorage.removeItem('deviceId');
          localStorage.removeItem('page');
        }
      }
    }
  }
  const loadDeviceInfo = async (deviceId, action = "", params) => {
    const url = `/api/device-check-charge-required/${deviceId}`
    const apiRes = await api_call(url);
    if (apiRes.ok) {
      const apiResObj = await apiRes.json()
      console.log("ChargeapiResObj::::", apiResObj)
      dispatch(layoutActions.closeDeviceListMenu());
      const userDeviceItem = apiResObj['device']
      if (action === "showDeviceCreditLogsPage") {
        showDeviceCreditLogsPage(userDeviceItem)
      }
      else if (action === "upload") {
        showDeviceAvatarPage(userDeviceItem)
      }
      else {
        // show device status view
        let chargeRequired = apiResObj['charge_required']
        if (chargeRequired === DEVICE_PAYMENT_STATUS.PAYMENT_REQUIRED) {
          showPaypalCreditLogsPage(userDeviceItem, chargeRequired)
          return false
        } else if (chargeRequired === DEVICE_PAYMENT_STATUS.PAYMENT_REMINDER) {
          if (checkShowPaypalBanner(deviceId)) {
            showPaypalCreditLogsPage(userDeviceItem, chargeRequired)
            return false
          }
        }
        dispatch(layoutActions.setCurrentDeviceId({ id: deviceId }));
      }
    }
  }
  //////////////////////////////////////////////////////////////////////////////////

  const state = location.state
  //console_log(`state::::::::::::::::::::::::::::::`, state)
  const showCreditLogdeviceInfo = state?.showCreditLogdeviceInfo
  //console_log(`showCreditLogdeviceInfo::::::::::::::::::::::::::::::`, showCreditLogdeviceInfo)
  useEffect(() => {
    if (showCreditLogdeviceInfo?.id) {
      setTimeout(() => {
        showDeviceCreditLogsPage(showCreditLogdeviceInfo)
      }, 700)
      history.replace({ ...location, state: {} });
    }
  }, [showCreditLogdeviceInfo?.id])
  ///////////////////////////////////////////////////////////////////////////////////

  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isPhone = useMediaQuery(theme.breakpoints.down('xs'));
  // console.log(isTablet + " " + isPhone);

  const [searchKeyword, setSearchKeyword] = useState('');

  const defaultSearchInputKeyword = new URLSearchParams(window.location.search).get('searchKeyword') ?? "";
  const [searchInputKeyword, setSearchInputKeyword] = useState(defaultSearchInputKeyword);
  const onChangeSearchInputKeyword = (event) => {
    const value = event.target.value
    setSearchInputKeyword(value)
  }
  const onPressSearchInputKeyword = (event) => {
    if (event.key === "Enter") {
      console.log(`Enter pressed::::`, searchInputKeyword, user.administrator);
      if (user.administrator) {
        //setSearchKeyword(searchInputKeyword);
        reloadDeviceList(searchInputKeyword);
      } else {
        setSearchKeyword(searchInputKeyword);
      }
      event.preventDefault(); // Optional: Prevent form submission or new line in textarea
    }
  }

  const onBlurSearchInputKeyword = (event) => {
    console.log(`onBlurSearchInputKeyword::::`, searchInputKeyword)
    if (user.administrator) {
      reloadDeviceList(searchInputKeyword);
    } else {
      setSearchKeyword(searchInputKeyword);
    }
  }

  const [collapsed, setCollapsed] = useState(false);
  // console.log(isTablet);

  const handleClose = () => {
    if (collapsed) {

      dispatch(layoutActions.openDeviceListMenu());
    }
    setCollapsed(!collapsed);

  };


  useEffect(() => setCollapsed(isTablet), [isTablet]);

  const deviceListMenu = useSelector((state) => state.layout.deviceListMenu);

  useEffect(() => {
    if (deviceListMenu === "close") {
      setCollapsed(true);
    }
  }, [deviceListMenu]);

  /////////////////////////////////////////start device avatar modal//////////////////////////////////////////
  const [deviceUploadModalOpen, setDeviceUploadModalOpen] = useState(false);
  const showDeviceAvatarPage = (device_tem) => {
    console.log("showDeviceAvatarPage::::", device_tem)
    setDeviceItem(device_tem)
    dispatch(layoutActions.closeDeviceListMenu());
    setDeviceUploadModalOpen(true)
  }
  /////////////////////////////////////////end device avatar modal////////////////////////////////////////////////////

  /////////////////////////////////////////start paypal credit logs modal//////////////////////////////////////////
  const [paypalCreditModalOpen, setPaypalCreditModalOpen] = useState(false);
  const [deviceItem, setDeviceItem] = useState({});
  const [chargeRequiredNum, setChargeRequiredNum] = useState(0);
  const showPaypalCreditLogsPage = (item, chargeRequired = 0) => {
    console.log("inputchargeRequired:", chargeRequired)
    dispatch(layoutActions.closeDeviceListMenu());
    setDeviceItem(item);
    setPaypalCreditModalOpen(true);
    setChargeRequiredNum(chargeRequired);
  }
  /////////////////////////////////////////end paypal credit logs modal////////////////////////////////////////////////////

  /////////////////////////////////////////start device credit logs modal//////////////////////////////////////////
  const [creditModalOpen, setCreditModalOpen] = useState(false);
  const showDeviceCreditLogsPage = (item) => {
    console_log(`showDeviceCreditLogsPage::::::::::::::::::::::::::::`, item)
    dispatch(layoutActions.closeDeviceListMenu());
    setDeviceItem(item)
    setCreditModalOpen(true)
  }
  /////////////////////////////////////////end device credit logs modal////////////////////////////////////////////////////


  const [deviceCountData, setDeviceCountData] = useState({});
  const updateDeviceCountData = (countData) => {
    //console_log("countData:::", countData)
    setDeviceCountData(countData)
  }

  const deviceReloadTimestamp = useSelector((state) => state.layout.deviceReloadTimestamp);
  const reloadDeviceList = async (searchKeyword) => {
    // if (window.localStorage.getItem('isAdministrator') === '1' && window.localStorage.getItem('show_all_cars') !== '1') {
    //   return false;
    // }
    if (is_null(searchKeyword)) {
      searchKeyword = new URLSearchParams(window.location.search).get('searchKeyword') ?? "";
    }
    const urlObj = new URL(window.location.href);
    urlObj.searchParams.set('searchKeyword', searchKeyword);
    window.history.replaceState({}, '', urlObj); // apply back to browser (without reload)

    if (user.id !== 0) {
      var url = `/api/devices?source=mainPage`;
      if (window.localStorage.getItem('isAdministrator') === '1' && searchKeyword) {
        url += `&searchKeyword=${searchKeyword}`;
      }
      const response = await api_call(url);
      if (response.ok) {
        const devices = await response.json();

        if (!user.administrator) {
          let filtered_device_list = devices
          dispatch(devicesActions.refresh(filtered_device_list));
          dispatch(devicesActions.refreshUserDeviceItems(filtered_device_list));
        } else {
          dispatch(devicesActions.refresh(devices));
          dispatch(devicesActions.refreshUserDeviceItems(devices));
        }
      }
    }
  }
  useEffect(() => {
    if (deviceReloadTimestamp && deviceReloadTimestamp > 0) {
      reloadDeviceList()
    }
  }, [deviceReloadTimestamp])

  const getSearchTextSpan = () => {
    const spanText = `${deviceCountData['online_device_count']}/${deviceCountData['device_count']}${user.administrator ? '/' + deviceCountData['inside_map_device_count'] : ''}`
    return spanText
  }

  const getSearchPlaceholder = () => {
    let placeholder = getSearchTextSpan()
    return placeholder
  }

  const getFilteredDeviceCount = () => {
    let cnt = 0
    if (deviceCountData['filtered_device_count']) {
      cnt = deviceCountData['filtered_device_count']
    }
    return cnt
  }

  const [showAllCars, setShowAllCars] = useState(window.localStorage.getItem('show_all_cars'));

  const onClickShowAll = () => {
    const show_all_cars = window.localStorage.getItem('show_all_cars') === '1' ? '0' : '1';
    window.localStorage.setItem('show_all_cars', show_all_cars);
    setShowAllCars(show_all_cars);
    if (show_all_cars === '1') {
      setSearchInputKeyword("");
      setSearchKeyword("");
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.set('searchKeyword', "");
      window.history.replaceState({}, '', urlObj); // apply back to browser (without reload)
      reloadDeviceList();
    }
  }


  return (
    <>
      <div className={classes.root}>
        <Map>
          {/* {!isTablet && <MapPadding left={parseInt(theme.dimensions.drawerWidthDesktop, 10)} />} */}
          {/* <CurrentLocationMap />
              <GeofenceMap />
              <AccuracyMap />  */}
          <CurrentPositionsMap
            showPaypalCreditLogsPage={showPaypalCreditLogsPage}
          />
          <SelectedDeviceMap />
          {/* <PoiMap /> */}
        </Map>
        <Button
          variant="contained"
          color={isPhone ? 'secondary' : 'primary'}
          classes={{ containedPrimary: classes.sidebarToggleBg }}
          className={classes.sidebarToggle}
          onClick={handleClose}
          disableElevation
        >
          <ListIcon />
          <div className={classes.sidebarToggleText}>{t('deviceTitle')}</div>
        </Button>
        <Paper square elevation={3} className={`${classes.sidebar} ${collapsed && classes.sidebarCollapsed}`}>
          <Paper className={classes.paper} square elevation={3}>
            <Toolbar className={classes.toolbar} disableGutters>
              {isTablet && (
                <IconButton onClick={handleClose}>
                  <ArrowBackIcon />
                </IconButton>
              )}
              <div className={classes.searchTextBox}>
                <TextField
                  fullWidth
                  name="searchKeyword"
                  value={searchInputKeyword}
                  autoComplete="searchKeyword"
                  onChange={(event) => onChangeSearchInputKeyword(event)}
                  onKeyDown={(event) => onPressSearchInputKeyword(event)}
                  onBlur={(event) => onBlurSearchInputKeyword(event)}
                  placeholder={getSearchPlaceholder()}
                  variant="filled"
                  InputProps={{
                    endAdornment: (
                      <>
                        {
                          (searchKeyword !== "") ? (
                            <span style={{ paddingLeft: '8px' }}>{getFilteredDeviceCount()}</span>
                          ) : (
                            <></>
                          )
                        }
                      </>
                    ),
                  }}
                />
              </div>
              <MainSort />

              {
                (user.administrator) ? (
                  <>
                    <IconButton onClick={() => onClickShowAll()} title="Show all">
                      <CheckIcon color={showAllCars === '1' ? 'secondary' : ''} />
                    </IconButton>
                  </>
                ) : (
                  <>
                    <IconButton onClick={() => history.push('/device')} title="Add device">
                      <AddIcon />
                    </IconButton>
                  </>
                )
              }

              {!isTablet && (
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              )}
            </Toolbar>
          </Paper>
          <div className={classes.deviceList}>
            <DevicesList
              filter={searchKeyword}
              updateDeviceCountData={updateDeviceCountData}
              showPaypalCreditLogsPage={showPaypalCreditLogsPage}
              showDeviceCreditLogsPage={showDeviceCreditLogsPage}
              showDeviceAvatarPage={showDeviceAvatarPage}
            />
          </div>
        </Paper>
        <BottomMenu />

        <>
          <PaypalCreditLogsModal
            open={paypalCreditModalOpen}
            setOpen={setPaypalCreditModalOpen}
            item={deviceItem}
            setItem={setDeviceItem}
            chargeRequiredNum={chargeRequiredNum}
          />
        </>

        <>
          <CreditLogsModal
            open={creditModalOpen}
            setOpen={setCreditModalOpen}
            item={deviceItem}
            setItem={setDeviceItem}
          />
        </>

        <>
          <EscrowLogsModal
            open={escrowLogsModalOpen}
            setOpen={setEscrowLogsModalOpen}
            item={escrowUser}
            setItem={setEscrowUser}
            modalType={'self'}
          />
        </>

        <>
          <DeviceImageUploadModal
            open={deviceUploadModalOpen}
            setOpen={setDeviceUploadModalOpen}
            item={deviceItem}
            setItem={setDeviceItem}
          />
        </>

      </div>
    </>
  )
}

export default MainPage;
